import { LoaderIcon } from '@/app/features/icons/Loader'
import { axiosInstance } from '@/lib/axios'
import { faCalendarSolid, FaIcon } from '@/lib/fa'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { TextAreaField } from '@/ui/form/controls/TextAreaField'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'

const NoteModal = ({
  close,
  companyId,
  driverId,
  dayType,
  date,
  existingNote,
  refreshActivities,
}) => {
  const { t } = useLocalize()
  const [isLoading, setIsLoading] = React.useState(false)
  const [noteText, setNoteText] = React.useState(existingNote || '')
  const formattedDate = date.format('YYYY-MM-DD')
  const saveNote = async ({
    deleteNote = false,
  }: { deleteNote?: boolean } = {}) => {
    setIsLoading(true)
    try {
      await axiosInstance.post(`/api/${companyId}/driverCalendar/changeNotes`, {
        driverId,
        dayType,
        date: formattedDate,
        notes: deleteNote ? '' : noteText,
      })
      refreshActivities()
      close()
    } catch (err) {
      console.error('Error saving note:', err)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <ModalLayout>
      <div className="tw-relative tw-flex tw-h-fit tw-w-[400px] tw-max-w-[400px] tw-flex-col tw-gap-2 tw-rounded-lg tw-bg-white tw-p-4">
        {isLoading && (
          <div className="tw-absolute tw-inset-0 tw-z-[900] tw-grid tw-place-items-center tw-bg-black/40">
            <LoaderIcon className="tw-animate-spin" />
          </div>
        )}
        <div className="tw-z-[90] tw-flex tw-w-full tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-gap-2">
            <span className="tw-text-base tw-font-semibold tw-text-content-base">
              {existingNote ? t('notes.edit-note') : t('notes.add-note')}
            </span>
            <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-base-300 tw-px-1 tw-py-1">
              <FaIcon
                icon={faCalendarSolid}
                className="tw-h-3 tw-w-3"
                onClick={() => close()}
              />
              <p className="tw-text-xs tw-text-content-base">{formattedDate}</p>
            </div>
          </div>

          <FaIcon
            icon={faClose}
            className="tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <TextAreaField
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          maxLength={382}
          placeholder={t('notes.note-placeholder')}
          fullWidth
          rows={4}
        />
        <div className="tw-flex tw-items-center tw-justify-between">
          <button
            disabled={isLoading}
            type="button"
            onClick={() => saveNote({ deleteNote: true })}
            className={`tw-cursor-pointer tw-rounded-lg tw-border tw-border-red-500 tw-bg-white tw-p-3 tw-text-sm tw-font-medium tw-text-red-500 hover:tw-opacity-80`}
          >
            {t('notes.delete-note')}
          </button>
          <button
            disabled={isLoading}
            type="button"
            onClick={() => saveNote()}
            className={`tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
          >
            {t('notes.save-note')}
          </button>
        </div>
      </div>
    </ModalLayout>
  )
}

export default NoteModal
